export default "__VITE_ASSET__M99lDkMi__"